import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class upcomingEvent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />
                <main className="main-area fix">
                    {/* breadcrumb-area */}
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                Event Info
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span
                                                className="beadcrumb-active"
                                                property="itemListElement"
                                                typeof="ListItem"
                                            >
                                                Upcoming Events
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    {/* about-area */}
                    <section className="Industry_Info">
                        <div className="container">
                            <div className="row" data-aos="fade-up" data-aos-delay={300}>
                                <div className="col-md-12 text-center">
                                    {/* <h4 class="border_title">Upcoming Events</h4> */}
                                    <div className="selector">
                                        <h2 className="ah-headline letters rotate-3">
                                            {/* <p>Conference Organisation</p> */}
                                            <span className="position_relative yellow_color">
                                                All Upcoming Events
                                            </span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt_40">
                                <div className="col-md-12">
                                    <div className="GoodwillMessages_grid_View">

                                        <div className="main_div">
                                            <img src="assets/img/UpcominEvent3.jpg" />
                                            <div className="content_div">
                                                {/* <p class="mb_0">3rd GTTES 2025 Mumbai & Metro Cities <br/>21st to 23rd February 2025</p> */}
                                                <p className="mb_0">ITME 2026</p>
                                            </div>
                                        </div>
                                        <div className="main_div">
                                            <img src="assets/img/UpcominEvent1.jpg" />
                                            <div className="content_div">
                                                <p className="mb_0">ITME Africa M.E.</p>
                                            </div>
                                        </div>
                                        <div className="main_div">
                                            <img src="assets/img/UpcominEvent2.jpg" />
                                            <div className="content_div">
                                                <p className="mb_0">GTTES</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(upcomingEvent));